import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_PARTNERS,
  GET_PARTNERS_SUCCESS,
  GET_PARTNERS_FAILED,
  GET_PARTNER_WITH_ID,
  GET_PARTNER_WITH_ID_SUCCESS,
  GET_PARTNER_WITH_ID_FAILED,
  GET_USERS_BY_PARTNERID,
  GET_USERS_BY_PARTNERID_SUCCESS,
  GET_USERS_BY_PARTNERID_FAILED,
  GET_USERS_BE_ADMIN_PARTNER_FAILED,
  GET_USERS_BE_ADMIN_PARTNER,
  GET_USERS_BE_ADMIN_PARTNER_SUCCESS,
  UPDATE_PARTNER_ADMIN,
  UPDATE_PARTNER_ADMIN_SUCCESS,
  UPDATE_PARTNER_ADMIN_FAILED,
  UPDATE_PARTNER_STATUS,
  UPDATE_PARTNER_STATUS_SUCCESS,
  UPDATE_PARTNER_STATUS_FAILED,
  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_FAILED,
  GET_PARTNERS_INVONTORY,
  GET_PARTNERS_INVONTORY_SUCCESS,
  GET_PARTNERS_INVONTORY_FAILED,
  GET_PARTNER_CATEGORIES,
  GET_PARTNER_CATEGORIES_FAILED,
  GET_PARTNER_CATEGORIES_SUCCESS,
} from './constants';

export const initialState: State = {
  partnersList: [],
  usersByPartnerId: [],
  usersBeAdminPartner: [],
  partnersInventoryList: [],
  partnerCategories: [],
  partner: [],
  count: 0,
  loading: false,
  error: '',
};

export const PartnersReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_PARTNERS:
        draft.loading = true;
        break;
      case GET_PARTNERS_SUCCESS:
        draft.partnersList = action.data;
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_PARTNERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PARTNER_WITH_ID:
        draft.loading = true;
        break;
      case GET_PARTNER_WITH_ID_SUCCESS:
        draft.partner = action.data;
        draft.loading = false;
        break;
      case GET_PARTNER_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_USERS_BY_PARTNERID:
        draft.loading = true;
        break;
      case GET_USERS_BY_PARTNERID_SUCCESS:
        draft.usersByPartnerId = action.data;
        draft.loading = false;
        break;
      case GET_USERS_BY_PARTNERID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PARTNER_CATEGORIES:
        draft.loading = true;
        break;
      case GET_PARTNER_CATEGORIES_SUCCESS:
        draft.partnerCategories = action.data;
        draft.loading = false;
        break;
      case GET_PARTNER_CATEGORIES_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_USERS_BE_ADMIN_PARTNER:
        draft.loading = true;
        break;
      case GET_USERS_BE_ADMIN_PARTNER_SUCCESS:
        draft.usersBeAdminPartner = action.data;
        draft.loading = false;
        break;
      case GET_USERS_BE_ADMIN_PARTNER_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case UPDATE_PARTNER_ADMIN:
      case CREATE_PARTNER:
      case UPDATE_PARTNER_STATUS:
        draft.loading = true;
        break;
      case UPDATE_PARTNER_ADMIN_SUCCESS:
      case CREATE_PARTNER_SUCCESS:
      case UPDATE_PARTNER_STATUS_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_PARTNER_ADMIN_FAILED:
      case CREATE_PARTNER_FAILED:
      case UPDATE_PARTNER_STATUS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PARTNERS_INVONTORY:
        draft.loading = true;
        break;
      case GET_PARTNERS_INVONTORY_SUCCESS:
        draft.partnersInventoryList = action.data;
        draft.loading = false;
        break;
      case GET_PARTNERS_INVONTORY_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      default:
        break;
    }
  });
export default PartnersReducer;
